export const fieldTranslations = {
  // Fields for transaction
  date: "Date de la transaction",
  c8_static_datum_name: "Actif",
  market_value_ptf_ccy: "Montant en devise de portefeuille",
  market_value_local_ccy: "Montant en devise locale",
  quantity: "Quantité",
  category: "Type de mouvement",
  description: "Description du mouvement",
  fees: "Frais",
  tax: "Taxes",

  // Technical fields
  c8_static_datum_id: "ID de l'actif",
  c8_static_datum_asset_class_1: "Classe d'actif principale",
  c8_static_datum_asset_class_2: "Sous-classe d'actif",
  c8_static_datum_currency: "Devise de l'actif",
  created_at: "Créé le",
  updated_at: "Mis à jour le",
  time_serie_file_id: "ID du fichier de série temporelle",
};
